const SP = 'sp:';
const PENDING = 'sp_pending';

export function saveScrollPosition(): void {
  if (typeof window === 'undefined') return;
  const url = window.location.pathname + window.location.search;
  sessionStorage.setItem(SP + url, String(Math.round(window.scrollY)));
}

export function markPendingRestore(url: string): void {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(PENDING, url);
}

// Returns true if restored, false if page not tall enough yet (async content still loading)
export function restoreScrollIfPending(): boolean {
  if (typeof window === 'undefined') return false;

  const pending = sessionStorage.getItem(PENDING);
  const current = window.location.pathname + window.location.search;
  if (!pending || pending !== current) return false;

  const saved = sessionStorage.getItem(SP + current);
  const y = saved ? parseInt(saved, 10) : NaN;
  if (isNaN(y) || y <= 0) {
    sessionStorage.removeItem(PENDING);
    return false;
  }

  // Only restore if page is tall enough; leave flag for async components otherwise
  if (document.documentElement.scrollHeight - window.innerHeight >= y) {
    sessionStorage.removeItem(PENDING);
    window.scrollTo(0, y);
    return true;
  }

  return false;
}
